import React, {useCallback, useEffect, useMemo, useState} from 'react';
import {NavLink, redirect, Route, Routes} from 'react-router-dom';
import {useDispatch, useSelector} from 'react-redux';
import Helmet from 'react-helmet';
import config from '../config';
import Login from './Login';

import {
    Alert,
    Box,
    Button,
    Card,
    CardContent,
    Container, Divider,
    Drawer,
    Grid, IconButton,
    Link,
    List, ListItem, ListItemIcon, ListItemText, MenuItem, MenuList,
    ThemeProvider,
    Toolbar, Typography
} from "@mui/material";

import Header from '../components/Common/Header'


import "./App.css"
import LoadingCircle from "../components/Common/Loading";
import theme from "../theme";
import {SnackBarProvider} from "../snackBarProvider";
import {Navigate} from "react-router";
import {configs, getDomainAlias} from "../constants";

import { MsalProvider, AuthenticatedTemplate, useMsal, UnauthenticatedTemplate } from '@azure/msal-react';
import {acquireToken} from "../core/api/authActions";
import {AltRoute, Rule, Send, SportsEsports, ViewQuilt} from "@mui/icons-material";
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import {styled} from "@mui/system";
import TypeSpecimenIcon from '@mui/icons-material/TypeSpecimen';
import FlagCircleIcon from '@mui/icons-material/FlagCircle';
import DonutLargeIcon from '@mui/icons-material/DonutLarge';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import AnimationIcon from '@mui/icons-material/Animation';
import FlagIcon from '@mui/icons-material/Flag';
import PrecisionManufacturingIcon from '@mui/icons-material/PrecisionManufacturing';
import SettingsSuggestIcon from '@mui/icons-material/SettingsSuggest';
import Audience from "./Audience";
import AudienceParameter from "./AdminPanel/AudienceParameter/AudienceParameter";
import Campaigns from "./Campaigns";
import CreateCampaignPage from "./Campaigns/CreateCampaignPage";
import CampaignAnalytics from "./Campaigns/CampaignAnalytics";

export default function App({instance}) {


    const dispatch = useDispatch();
    const userSession = useSelector((state) => state.data.UserSession);

    useEffect(() => {
        console.log("MSAL Instance changed", instance.getActiveAccount());
    }, [instance]);

    useEffect(() => {
        if (!userSession.fetching) return;
        console.log('acquireToken')
        acquireToken(dispatch, instance);
    }, [dispatch, userSession.fetching]);


    const NotFound = () => {
        return (
            <Card>
                <CardContent>
                    <h1>404 - Page Not Found</h1>
                    <p>Sorry, the page you are looking for could not be found.</p>
                    <Button component={Link} href={"/"}>To main page</Button>
                </CardContent>
            </Card>
        );
    };

    const getContent = useCallback(() => {
        console.log('getContent')
        let Content

        Content =
            <Routes>
                {menu.map((object, index) => (
                    !object.isInfoElement && <Route key={index} path={object.path} element={object.element}/>
                ))}
                <Route path='/' element={<Campaigns />}/>
                <Route path='/createCampaign' element={<CreateCampaignPage />}/>
                <Route path='/updateCampaign/:id' element={<CreateCampaignPage />}/>
                <Route path='/createCampaign/:id/:action' element={<CreateCampaignPage />}/>
                <Route path='/analytics/:id' element={<CampaignAnalytics />}/>
                {/*<Route path='/redirect' element={<LevelsChain />}/>*/}
                {/*<Route*/}
                {/*    path="/redirect"*/}
                {/*    element={<Navigate to="/" replace />}*/}
                {/*/>*/}
                <Route path="*" element={<NotFound />} />
            </Routes>
        return Content
    })

    const [drawerOpen, setDrawerOpen] = useState(false);

    const handleDrawerOpen = (open) =>{
        setDrawerOpen(open);
    };

    const menu = useMemo(() => [
        {title: 'Main', isDividerAfter: false, isInfoElement: true},

        {
            to: `/campaign`,
            path: '/campaign',
            title: 'Campaign',
            element: <Campaigns />,
            icon: <Send size={"small"}/>,
            isDividerAfter: false,
            isInfoElement: false
        },
        {
            to: `/audience`,
            path: '/audience',
            title: 'Audience',
            element: <Audience />,
            icon: <PrecisionManufacturingIcon size={"small"}/>,
            isDividerAfter: true,
            isInfoElement: false
        },
        {title: 'Configs', isDividerAfter: false, isInfoElement: true},

        {
            to: `/parameter`,
            path: 'parameter',
            title: 'Audience Requirements',
            element: <AudienceParameter />,
            icon: <Rule size={"small"}/>,
            isDividerAfter: false,
            isInfoElement: false
        },

    ]);
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (drawerOpen &&
                !document.querySelector('.MuiDrawer-root').contains(event.target) &&
                !document.querySelector('.MuiToolbar-root').contains(event.target) &&
                !document.querySelector('.menu-title').contains(event.target)) {
                setDrawerOpen(false)
            }
        };
        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [drawerOpen]);

    return (
        <MsalProvider instance={instance}>
            <ThemeProvider theme={theme}>
                <Helmet {...config.app}></Helmet>

                <Header
                    handleDrawerOpen={handleDrawerOpen}
                    open={drawerOpen}
                />


                <Drawer
                    sx={{
                        width: 250,
                        flexShrink: 0,
                        '& .MuiDrawer-paper': {
                            width: 250,
                            boxSizing: 'border-box',
                        },
                    }}
                    variant="permanent"

                >

                    <Divider sx={{pt:6}} />
                    <MenuList>
                        {menu.filter(object => object.disabled!=true).map((object, index) => (
                            !object.isInfoElement ?
                                <Box key={index}>
                                    <MenuItem
                                        component={NavLink}
                                        to={object.to}
                                        onClick={() => {
                                            handleDrawerOpen(false)
                                        }}
                                        disabled={object.disabled}
                                        key={object.to}
                                        className={({ isActive }) => (isActive ? 'Mui-selected' : '')}
                                    >
                                        <ListItemIcon>
                                            {object.icon}
                                        </ListItemIcon>
                                        <ListItemText>{object.title}</ListItemText>

                                    </MenuItem>
                                    {object.isDividerAfter &&
                                        <Divider/>
                                    }
                                </Box> :
                                <MenuItem
                                    component={Box}
                                    disabled={true}
                                    className={"pending"}
                                    key={object.title}
                                >
                                    <ListItemText>{object.title}</ListItemText>

                                </MenuItem>

                        ))}

                    </MenuList>
                </Drawer>


                <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
                    <Toolbar />

                    <AuthenticatedTemplate>
                        <Box sx={{p:0}}>
                            {getContent()}
                        </Box>
                    </AuthenticatedTemplate>
                    <UnauthenticatedTemplate>

                        <Alert severity={"info"}>
                            Sign-in to get access
                        </Alert>
                    </UnauthenticatedTemplate>
                </Box>


            </ThemeProvider>
        </MsalProvider>
    );
}

